<template>
  <div
    class="cover flex-col"
    @click="menuList = null"
    @mousemove="moveClient"
    @mouseup="mouseUp"
    style="position: relative"
  >
    <el-collapse-transition>
      <div class="search-box" v-show="isShow" id="canvas">
        <div class="justify-between content">
          <div class="left-input-box">
            <div class="align-center input-select">
              <el-autocomplete
                placeholder="請輸入關鍵詞檢索，或者在左側選擇文獻閲讀"
                v-model="newParam.keyword"
                class="input-select"
                @click.stop.native
                @keyup.enter.native="clickSearch(true)"
                style="margin-bottom: 0"
                type="search"
                :fetch-suggestions="
                  (queryString, cb) => {
                    getStorages(queryString, cb, 'keyword');
                  }
                "
              >
                <el-select
                  v-model="newParam.searchType"
                  slot="prepend"
                  placeholder="請選擇"
                  style="width: 120px"
                >
                  <el-option label="一般檢索" value="0"></el-option>
                  <el-option label="進階檢索" value="1"></el-option>
                  <!--                  <el-option label="NEAR檢索" value="2"></el-option>-->
                </el-select>
                <el-select
                  v-if="newParam.searchType === '1'"
                  v-model="newParam.textType"
                  style="width: 80px; margin-left: 20px"
                  slot="prepend"
                  placeholder="請選擇"
                >
                  <el-option label="正文" value="1"></el-option>
                  <el-option label="校記" value="2"></el-option>
                  <el-option label="專名" value="3"></el-option>
                </el-select>
                <!-- <img slot="append" class="after" src="/static/icon/data.png" /> -->
              </el-autocomplete>
              <el-button
                type="primary"
                class="submit-btn"
                :icon="loading ? 'el-icon-loading' : ''"
                round
                @click.stop="clickSearch(true)"
              >
                <img
                  v-if="!loading"
                  style="height: 1rem; width: auto"
                  src="/static/search.png"
                  alt=""
                />
              </el-button>
            </div>
            <template v-if="newParam.searchType === '1'">
              <el-autocomplete
                v-for="(item, index) in advancedQuery"
                :key="index + 'ad'"
                placeholder="請輸入内容"
                @click.stop.native
                v-model="item.keyword"
                @keyup.enter.native="clickSearch(true)"
                class="input-select"
                :fetch-suggestions="
                  (queryString, cb) => {
                    getStorages(queryString, cb, 'advanced' + index);
                  }
                "
              >
                <el-select
                  v-model="item.type"
                  style="width: 120px; margin-right: 20px"
                  slot="prepend"
                  placeholder="請選擇"
                >
                  <el-option label="OR" value="or"></el-option>
                  <el-option label="AND" value="and"></el-option>
                  <el-option label="NOT" value="not"></el-option>
                </el-select>
                <el-select
                  v-model="item.textType"
                  style="width: 80px"
                  slot="prepend"
                  placeholder="請選擇"
                >
                  <el-option label="正文" value="1"></el-option>
                  <el-option label="校記" value="2"></el-option>
                  <el-option label="專名" value="3"></el-option>
                </el-select>
                <img
                  slot="append"
                  class="after"
                  @click.stop="advancedQuery.splice(index, 1)"
                  src="/static/icon/delete.png"
                />
              </el-autocomplete>
            </template>
            <template v-if="newParam.searchType === '2'">
              <el-autocomplete
                v-for="(item, index) in neardQuery"
                :key="index + 'ne'"
                placeholder="請輸入内容"
                :fetch-suggestions="
                  (queryString, cb) => {
                    getStorages(queryString, cb, 'neard' + index);
                  }
                "
                @click.stop.native
                @keyup.enter.native="clickSearch(true)"
                v-model="item.keyword"
                class="input-select input-select-label"
                style="padding-right: 0px"
              >
                <div slot="prepend">
                  NEAR字距
                  <el-select
                    v-model="item.type"
                    v-if="item.type"
                    style="width: 120px; padding: 0 20px"
                    slot="prepend"
                    placeholder="請選擇"
                  >
                    <el-option label="OR" value="or"></el-option>
                    <el-option label="AND" value="and"></el-option>
                    <el-option label="NOT" value="not"></el-option>
                  </el-select>
                  <el-input-number
                    v-model="item.spacing"
                    style="width: 100px"
                    :min="1"
                    :max="30"
                    controls-position="right"
                  >
                  </el-input-number>
                </div>
              </el-autocomplete>
            </template>

            <div class="justify-between content">
              <div>
                <template v-if="newParam.searchType === '0'">
                  <el-button size="small" @click.stop="clearsearch"
                    >清除關鍵詞
                    <i class="iconfont icon-delete"></i>
                    ></el-button
                  >
                </template>

                <template v-if="newParam.searchType === '1'">
                  <!-- <el-button
                  size="small"
                  @click.stop="
                    advancedQuery.push({
                      type: 'and',
                      keyword: '',
                    })
                  "
                  >增加條件 <i class="el-icon-plus"></i
                ></el-button> -->
                  <el-button
                    size="small"
                    @click.stop="clearsearch"
                    style="margin-right: 15px"
                    >清除所有關鍵詞
                    <!-- <i class="el-icon-delete"></i> -->
                    <i class="iconfont icon-delete"></i>
                  </el-button>
                  <!-- @click="
                    isSearching = false;

                    advancedQuery = [];
                    search.keyword = '';
                  " -->
                </template>
                <template v-if="newParam.searchType === '2'">
                  <el-button
                    size="small"
                    @click.stop="clearsearch"
                    style="margin-right: 15px"
                    >清除條件
                    <!-- <i class="el-icon-delete"></i -->
                    <i class="iconfont icon-delete"></i>
                  </el-button>
                </template>
                <el-checkbox class="checkboxstyle" v-model="searchAccuracyType"
                  >漢字關聯</el-checkbox
                >
              </div>
            </div>
          </div>

          <div class="search-range">
            <!-- <div class="zdbox">
            
              <el-checkbox v-model="newIsCheck" @change="setRangeType(11)"
                >自定義檢索範圍</el-checkbox
              >
              <div v-show="xdwenxian" class="zdxuanze">
                <span class="kuohao">(</span
                ><span class="xdwenxian"> {{ xdwenxian }} </span
                ><span class="kuohao">)</span>
              </div>
              <div v-show="!xdwenxian" class="weixuanze">
                <span><i>(</i>書名，作者檢索<i>)</i></span>
              </div>
            </div> -->
            <!-- <div class="select-range justify-between">
              <el-checkbox
                :value="rangeType == 1"
                @click.stop.native
                @change="setRangeType(1)"
                >全庫</el-checkbox
              >
              <span>
                <el-checkbox
                  :value="rangeType == 2"
                  @click.stop.native
                  @change="setRangeType(2)"
                  >自定義</el-checkbox
                >

                <i
                  class="iconfont icon-delete"
                  style="font-size: 16px"
                  @click.stop="clearSearchTree"
                ></i>
              </span>
            </div> -->
            <el-dialog
              :visible.sync="isVisiableCustomRange"
              style="margin-top: 26px"
              :before-close="handleClose"
            >
              <div>
                <span
                  class="btn"
                  :class="customRangeType === 'category' && 'active'"
                  @click.stop="
                    customRangeType = 'category';
                    clearSearchTree();
                  "
                  >部類書名檢索
                </span>
                <span
                  class="btn"
                  :class="customRangeType === 2 && 'active'"
                  @click.stop="
                    customRangeType = 2;
                    clearSearchTree();
                  "
                  >作者檢索
                </span>
              </div>
              <div v-show="customRangeType === 'category'">
                <el-autocomplete
                  size="small"
                  class="marginNew"
                  @input="getCategory()"
                  v-model="search.category"
                  placeholder="請輸入書名"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'category');
                    }
                  "
                >
                  <!-- <i
                  slot="suffix"
                  class="el-icon el-icon-search search-icon"
                  @click.stop="getCategory()"
                ></i> -->
                </el-autocomplete>
                <el-tree
                  v-show="selectTreeIndex === 0"
                  :default-expand-all="isCategorySearch"
                  ref="scopeTreeCat"
                  :key="isCategorySearch ? 'isCategorySearch' : '1'"
                  :data="treeList.category"
                  :props="defaultProps"
                  node-key="key"
                  show-checkbox
                >
                  <span slot-scope="{ node, data }">
                    <span
                      v-if="data"
                      @click="getDetail(node.isLeaf, data)"
                      v-html="
                        isCategorySearch
                          ? hightLighyt(data.name, search.category)
                          : data.name
                      "
                    >
                    </span>
                  </span>
                </el-tree>
              </div>
              <div v-show="customRangeType === 2">
                <div class="margin">
                  <div class="margin-ri">
                    <el-checkbox
                      :value="isAuth == 'pinyin'"
                      @click.stop.native
                      @change="
                        isAuth = 'pinyin';
                        clearSearchTree();
                      "
                      >音序</el-checkbox
                    >
                  </div>
                  <div class="margin-ri">
                    <el-checkbox
                      :value="isAuth == 'dynasty'"
                      @click.stop.native
                      @change="
                        isAuth = 'dynasty';
                        clearSearchTree();
                      "
                      >朝代
                    </el-checkbox>
                  </div>
                </div>
                <el-autocomplete
                  size="small"
                  class="margin"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'pinyin');
                    }
                  "
                  v-if="isAuth == 'pinyin'"
                  @input="getPinyin()"
                  v-model="search.pinyin"
                  placeholder="請輸入作者"
                >
                  <!-- <i
                  slot="suffix"
                  class="el-icon el-icon-search search-icon"
                  @click.stop="getPinyin()"
                ></i> -->
                </el-autocomplete>
                <el-autocomplete
                  size="small"
                  class="margin"
                  :fetch-suggestions="
                    (queryString, cb) => {
                      getStorages(queryString, cb, 'dynasty');
                    }
                  "
                  v-if="isAuth == 'dynasty'"
                  @input="getDynasty()"
                  v-model="search.dynasty"
                  placeholder="請輸入作者"
                >
                  <!-- <i
                  slot="suffix"
                  class="el-icon el-icon-search search-icon"
                  @click.stop="getDynasty()"
                ></i> -->
                </el-autocomplete>
                <div v-show="isAuth === 'pinyin'">
                  <el-tree
                    ref="scopeTreeWriter"
                    node-key="key"
                    :default-expand-all="isPinyinSearch"
                    :key="isPinyinSearch ? 'isPinyinSearch' : '1'"
                    :data="treeList.pinyin"
                    :props="defaultProps"
                    show-checkbox
                  >
                    <span slot-scope="{ node, data }">
                      <span
                        v-if="data"
                        @click="getDetail(node.isLeaf, data)"
                        v-html="
                          isPinyinSearch && !node.isLeaf
                            ? hightLighyt(data.name, search.pinyin)
                            : data.name
                        "
                      ></span>
                    </span>
                  </el-tree>
                </div>
                <div v-show="isAuth === 'dynasty'">
                  <el-tree
                    ref="scopeTreeWriterDynasty"
                    node-key="key"
                    :default-expand-all="isDynastySearch"
                    :key="isDynastySearch ? 'isDynastySearch' : '1'"
                    :data="treeList.dynasty"
                    :props="defaultProps"
                    show-checkbox
                  >
                    <span slot-scope="{ node, data }">
                      <span
                        v-if="data"
                        @click="getDetail(node.isLeaf, data)"
                        v-html="
                          isDynastySearch && !node.isLeaf
                            ? hightLighyt(data.name, search.dynasty)
                            : data.name
                        "
                      ></span>
                    </span>
                  </el-tree>
                </div>
              </div>
              <el-divider></el-divider>

              <span class="btn active" @click.stop="setRangeType(2)"
                >確認範圍
                <!-- <img src="/static/search.png" alt="" style="height: 1rem" /> -->
              </span>
            </el-dialog>
          </div>
        </div>
      </div>
    </el-collapse-transition>
    <div class="topbottom">
      <img
        class="totop"
        v-show="isShow"
        src="/static/icon/top.png"
        alt=""
        @click="changeShow()"
      />
      <img
        class="tobottom"
        v-show="!isShow"
        src="/static/icon/bottom.png"
        alt=""
        @click="changeShow()"
      />
    </div>
    <div class="content-box">
      <div
        class="tree-list heitani"
        ref="leftDragCate"
        :style="{ height: leftHeight + 'vh' }"
      >
        <div
          class="drag-box"
          @mousedown="getClientInfo($event, 'leftDragCate')"
        ></div>
        <!-- 左侧树状结构 -->
        <div class="borderline">
          <div class="borderlinecon"></div>
          <div class="justify-between align-center simplestyle">
            <span></span>
            <!-- <img src="/static/icon/left.png" class="" /> -->
            <el-button
              size="small"
              :type="isSimple ? 'primary' : ''"
              round
              @click="changePermitTwo(true, '1')"
              >檢索結果目録</el-button
            >
            <el-button
              size="small"
              :type="!isSimple ? 'primary' : ''"
              round
              @click="changePermitTwo(false, 0)"
              >全庫結果分佈</el-button
            >
            <span></span>
          </div>
          <div class="treescroll">
            <!--             "全結構模式" : "簡潔模式"-->
            <div class="tree">
              <div class="justify-between align-center titles">
                <!-- <span>《儒藏》精华篇 </span> -->
                <span>部類 </span>
                <i
                  :class="
                    searchTree.tree === 1
                      ? 'el-icon-caret-bottom'
                      : 'el-icon-caret-right'
                  "
                  @click="searchTree.tree = searchTree.tree === 1 ? 0 : 1"
                  class="right-icon"
                ></i>
              </div>
              <transition name="fade-in">
                <el-tree
                  :empty-text="emptyText"
                  ref="treeList"
                  v-show="searchTree.tree"
                  v-if="searchResult.tree"
                  :data="searchResult.tree"
                  :default-expand-all="true"
                  :check-on-click-node="true"
                  :expand-on-click-node="false"
                  @check="setSearchFilter()"
                  @node-click="isornotpermit"
                  node-key="id"
                  :props="searchTreeProps"
                  :filter-node-method="getFilter"
                  show-checkbox
                >
                  <span class="span-ellipsis" slot-scope="{ node, data }">
                    <span
                      v-show="!isSimple && data.totalNum > 0"
                      class="xinghao"
                      >*</span
                    ><span
                      :style="{
                        color: !isSimple && data.isPermit == 0 ? '#bbb' : '',
                      }"
                      >{{ node.label }}</span
                    >
                  </span>
                </el-tree>
              </transition>
            </div>

            <div class="tree">
              <div class="justify-between align-center titles">
                <span>作者</span>
                <i
                  :class="
                    searchTree.writer
                      ? 'el-icon-caret-bottom'
                      : 'el-icon-caret-right'
                  "
                  @click="searchTree.writer = searchTree.writer === 1 ? 0 : 1"
                  class="right-icon"
                ></i>
              </div>

              <el-checkbox-group
                class="padding-left left-width"
                @change="setSearchFilter($event, 'writerIds')"
                v-model="searchFilter.writerIds"
                v-show="searchTree.writer"
                v-if="searchResult.writerList"
              >
                <el-checkbox
                  v-for="item in searchResult.writerList"
                  :label="item.key"
                  :key="item.key"
                  :value="item.key"
                  style="width: 50%; margin-right: 0; height: 26px"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>

            <div class="tree" style="border: none">
              <div class="justify-between align-center titles">
                <span>朝代</span>
                <i
                  :class="
                    searchTree.dynasty
                      ? 'el-icon-caret-bottom'
                      : 'el-icon-caret-right'
                  "
                  @click="searchTree.dynasty = searchTree.dynasty === 1 ? 0 : 1"
                  class="right-icon"
                ></i>
              </div>
              <el-checkbox-group
                class="padding-left left-width"
                @change="setSearchFilter($event, 'dynastyIds')"
                v-model="searchFilter.dynastyIds"
                v-show="searchTree.dynasty"
                v-if="searchResult.dynastyList"
              >
                <el-checkbox
                  v-for="item in searchResult.dynastyList"
                  :label="item.key"
                  :key="item.key"
                  :value="item.key"
                  style="width: 50%; margin-right: 0; height: 26px"
                >
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>

            <div
              class="second-btn-box"
              v-if="isSearchFilter"
              :style="{ width: $refs.leftDragCate.clientWidth + 'px' }"
            >
              <el-button
                type="primary"
                @click="
                  searchFilter.type = '0';
                  clickSearch(false, true);
                "
                class="second-btn"
                size="mini"
              >
                確定
              </el-button>
            </div>
          </div>
          <div class="borderlinecon"></div>
        </div>
      </div>
      <!--      <div-->
      <!--        class="tree-list heitani"-->
      <!--        ref="leftDragCate"-->
      <!--        :style="{ height: leftHeight + 'vh', paddingBottom: '1rem' }"-->
      <!--        v-else-->
      <!--      >-->
      <!--        <div-->
      <!--          class="drag-box"-->
      <!--          @mousedown="getClientInfo($event, 'leftDragCate')"-->
      <!--        ></div>-->
      <!--        <div class="borderline">-->
      <!--          <div class="borderlinecon"></div>-->
      <!--          <div class="treescroll">-->
      <!--            <div class="tree" style="borderbottom: none">-->
      <!--              <div class="justify-between align-center titles">-->
      <!--                &lt;!&ndash; <span>《儒藏》精华篇 </span> &ndash;&gt;-->
      <!--                <span>部類 </span>-->
      <!--                <div>-->
      <!--                  <el-button-->
      <!--                    v-show="isShowQuanKu"-->
      <!--                    size="small"-->
      <!--                    :type="!isSimple ? 'primary' : ''"-->
      <!--                    round-->
      <!--                    @click="changePermit"-->
      <!--                    >全庫</el-button-->
      <!--                  >-->
      <!--                  <i-->
      <!--                    :class="-->
      <!--                      searchTree.tree === 1-->
      <!--                        ? 'el-icon-caret-bottom'-->
      <!--                        : 'el-icon-caret-right'-->
      <!--                    "-->
      <!--                    @click="changeTreeIndexSearch()"-->
      <!--                    class="right-icon"-->
      <!--                  ></i>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <transition name="fade-in">-->
      <!--                <el-tree-->
      <!--                  :empty-text="emptyText"-->
      <!--                  :render-content="rendercontent"-->
      <!--                  ref="defaultSearchTree"-->
      <!--                  :default-expand-all="true"-->
      <!--                  :data="searchResult.tree"-->
      <!--                  :props="defaultTreeProps"-->
      <!--                  node-key="id"-->
      <!--                  :check-on-click-node="true"-->
      <!--                  :expand-on-click-node="false"-->
      <!--                  :filter-node-method="getDefaltFilter"-->
      <!--                  @check="getTreeDefaultSearch"-->
      <!--                  @node-click="isornotpermit"-->
      <!--                  show-checkbox-->
      <!--                  :highlight-current="true"-->
      <!--                >-->
      <!--                  &lt;!&ndash; <span class="custom-tree-node" slot-scope="{ node, data }">-->
      <!--                    <span-->
      <!--                      v-if="catalogIdList && catalogIdList.includes(data.id)"-->
      <!--                      >*</span-->
      <!--                    ><span>{{ node.label }}</span>-->
      <!--                  </span> &ndash;&gt;-->
      <!--                </el-tree>-->
      <!--                &lt;!&ndash; :data="treeList.category" &ndash;&gt;-->
      <!--              </transition>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div class="borderlinecon"></div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="select-content flex-grow">
        <!-- 搜索正文 -->
        <el-card>
          <div
            class="heitani"
            v-if="searchResult.bookList && searchResult.bookList.length"
            :style="{ height: contHeight + 'vh', overflowY: 'scroll' }"
            v-infinite-scroll="newload"
            infinite-scroll-disabled="newdisabled"
            infinite-scroll-distance="10"
          >
            <!-- Collapse 折叠面板 -->
            <el-collapse :value="activeName" @change="getBookListOpenStatus">
              <el-collapse-item
                :disabled="!isSearching"
                v-for="item in searchResult.bookList"
                :key="item.id"
                :name="item.bookName"
              >
                <template #title>
                  <span
                    :key="activeName && activeName[item.bookName]"
                    class="head-title justify-between cursorauto"
                  >
                    <div>
                      <span
                        class="cursorpointer"
                        @click.stop="gotoBookDetail(item)"
                        >{{ item.bookName }}</span
                      >
                      <!-- <span class="book-number">（越南之部一册）</span> -->
                      <span class="sm-title">命中{{ item.hitNum }}頁</span>
                      <i
                        style="margin-left: 24px"
                        :class="
                          openSearchStatus[item.bookName]
                            ? 'el-icon-arrow-right'
                            : 'el-icon-arrow-down'
                        "
                        @click.stop="closeAllList(item)"
                      />
                      <div class="search-content-box" @click.stop="">
                        <div class="search-info-box flex">
                          <span class="search-info align-center">
                            <img src="/static/icon/cate.png" class="icon" />
                            {{ item.categoryName }}
                          </span>
                          <span class="search-info align-center">
                            <img src="/static/icon/user.png" class="icon" />
                            <!-- {{ item.writer }} -->
                            <ul v-for="(w, key, i) in item.writerarr" :key="i">
                              <li v-if="i != 0">，</li>
                              <li v-for="(ww, ii) in w" :key="ii">
                                <i v-if="ii != 0">、</i>
                                [{{ ww.writerDynastyName }}]<i
                                  @click="
                                    linkdialog(
                                      item.writerList,
                                      item.copierList,
                                      ww.writerName,
                                      item.bookName
                                    )
                                  "
                                  class="cursor"
                                  >{{ ww.writerName }}</i
                                ><i v-if="ii + 1 == w.length">{{ key }}</i>
                              </li>
                            </ul>
                          </span>
                          <span class="search-info align-center">
                            <img src="/static/icon/auth.png" class="icon" />
                            <!-- {{ item.copier }}校點 -->
                            <span v-for="(c, ci) in item.copierList" :key="ci"
                              ><i v-if="ci != 0">、</i
                              ><i
                                @click="
                                  linkdialog(
                                    item.writerList,
                                    item.copierList,
                                    c.copierName,
                                    item.bookName
                                  )
                                "
                                class="cursor"
                                >{{ c.copierName }}</i
                              ></span
                            >校點
                          </span>
                          <!-- <span class="search-info align-center">
                            <img
                              v-if="item.dcUrl"
                              src="/static/icon/temp.png"
                              class="icon"
                            />
                            <img
                              v-else
                              src="/static/icon/temp1.png"
                              :style="{ width: '1.35rem', height: '1.35rem' }"
                              class="icon"
                            />

                            底本參考
                          </span> -->
                          <span class="search-info align-center">
                            <img src="/static/icon/public.png" class="icon" />
                            {{ item.publishTime }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span>{{ activeName && activeName[item.bookName] }}</span>
                    <div>
                      <!-- 该icon透明度为0，模拟原来的按钮不能传参 ,同事slot不更新数据，所以原箭头禁止鼠标事件，只负责展示 -->
                      <i
                        :class="
                          activeName && activeName[item.bookName]
                            ? 'el-icon-arrow-right'
                            : 'el-icon-arrow-down'
                        "
                        @click.stop="openBook(item)"
                      ></i>
                    </div>
                  </span>
                </template>
                <div class="search-content-box" v-if="searchFilter.type != 3">
                  <!-- <el-collapse
                  v-model="activeListName[item.id]"

                  accordion
                > -->
                  <div
                    v-for="(list, idx) in item.bookJuanList"
                    :key="`${idx}${list.juanName}`"
                    v-if="
                      idx == 0 ||
                      openSearchStatus[item.id] ||
                      openSearchStatus[item.bookName]
                    "
                    :name="list.juanName"
                  >
                    <div class="juan-title justify-between">
                      <span>
                        {{ list.juanName }}
                        <!--                        <span class="num"> 命中{{ list.hitNum }}次 </span>-->
                      </span>
                      <div
                        @click="
                          openJuanStatus[list.juanName] =
                            !openJuanStatus[list.juanName];
                          $forceUpdate();
                        "
                      >
                        <i
                          :class="
                            openJuanStatus[list.juanName]
                              ? 'el-icon-arrow-right'
                              : 'el-icon-arrow-down'
                          "
                        />
                      </div>
                    </div>
                    <div v-if="!openJuanStatus[list.juanName]">
                      <div
                        class="search-content flex list"
                        :key="page.id + page.text"
                        v-for="(page, index) in list.bookPageList"
                        v-if="
                          index < 3 ||
                          openSearchStatus[item.id] ||
                          openSearchStatus[item.bookName]
                        "
                      >
                        <div class="sort">
                          {{ index + 1 }}.

                          <i
                            class="el-icon-warning-outline"
                            v-if="page.hitType == 2"
                          />
                        </div>
                        <div
                          class="content cursorpointer"
                          @click="
                            viewDetail(
                              page,
                              page.bookId,
                              page.id,
                              item.bookName
                            )
                          "
                          v-html="page.text"
                        ></div>
                        <!-- <img
                          class="book-icon"
                          @click="
                            viewDetail(
                              page,
                              page.bookId,
                              page.id,
                              item.bookName
                            )
                          "
                          src="/static/icon/view.png"
                        /> -->
                      </div>
                    </div>
                    <!-- 剩余 -->
                    <div
                      v-show="
                        (item.bookJuanList.length > 1 ||
                          list.bookPageList.length > 3) &&
                        !openSearchStatus[item.id] &&
                        !openSearchStatus[item.bookName]
                      "
                      class="justify-between"
                    >
                      <a></a>
                      <a style="cursor: pointer" @click="viewMoreList(item)"
                        >更多結果>></a
                      >
                    </div>
                  </div>
                  <!-- </el-collapse> -->
                </div>
                <div
                  class="mengban"
                  v-if="item.isPermit == 0"
                  @click="clickChangeBuy(true)"
                ></div>
              </el-collapse-item>
            </el-collapse>
            <!-- Collapse 折叠面板结束 -->
            <!-- <div v-if="isSearching"> -->
            <p v-if="newloading">加载中...</p>
            <p v-if="noMore">
              {{
                isSearching
                  ? "以上就是本次檢索的所有結果"
                  : "以上就是本次選中的所有結果"
              }}
            </p>
            <!-- </div> -->
            <!-- 分页 -->
            <!-- <div class="justify-end" style="font-size:25px;padding-top:10px" v-else>
              <el-pagination
                @current-change="empSearchChange"
                layout="prev, pager, next,total"
                :total="empsearch.total"
                :current-page="empsearch.pageNum"
                :page-size="empsearch.pageSize"
                prev-text="上一頁"
                next-text="下一頁"
              >
              </el-pagination>
            </div> -->
            <!-- 分页end -->
          </div>
          <el-empty
            class="heitani"
            v-else
            :style="{ height: contHeight + 'vh' }"
            :image-size="200"
            :description="description"
          ></el-empty>
        </el-card>
      </div>
    </div>
    <!-- 关系图预览 -->
    <el-dialog
      :title="activewriter"
      :visible.sync="linkVisible"
      width="70%"
      height="60%"
      min-width="900px"
    >
      <EchartGx
        :writerIds="writerIds"
        :copierIds="copierIds"
        :activewriter="activewriter"
        :bookName="activeBookName"
      ></EchartGx>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus.js"
// import Analysis from "./analysis.vue"
// import EchartGx from "@/components/echart-gxnew.vue"
import {
  getInfo,
  getlistByIdsApi,
  // getBookList,
  booksTree,
  essearch,
  // getCategoryNode,
  // getDynastyList,
  // getWriterList,
  // getMainSum,
  // getNoteSum,
  exportSearchResult,
  getHitCount,
  addLatest
} from "@/api/api"
// import moment from "moment";
export default {
  name: "WordTest",
  components: {
    // Analysis,
    // EchartGx,
  },
  data () {
    return {
      // isReload: true,
      isShowQuanKu: true,//是否展示全库按钮 沒登錄不展示
      emptyText: "查詢中...",

      historyList: { keyword: [], advanced1: [], advanced2: [] },//历史记录
      linkVisible: false,
      activeBookName: "",//关系图弹窗 书名
      activewriter: "",//关系图弹窗 查询作者
      writerIds: [],//关系图弹窗作者或校验Id
      copierIds: [],//关系图弹窗作者或校验Id
      dialogTableVisible: false,//数据分析柱状图默认不展示
      xAxisdata: [],//条形统计图数据
      seriesdata: [],//条形统计图数据
      // leftHeight:'86vh',
      // contHeight:'76vh',
      leftHeight: 87,
      contHeight: 76,
      isShow: true,//搜索框是否展示
      chaoShow: false,
      changestate: "全部展開",
      searchWord: "",
      search: {
        //搜索框数据
        pinyin: "",
      },
      description: "請在上方輸入關鍵詞檢索，或者在左側選擇文獻閲讀",
      searchParams: {
        // keyword: "正文"
        // advaList: {}
      },
      // sortType:0,//排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
      searchResult: {
        bookList: [],
      },
      // searchType: "1",
      rangeType: "1",
      newIsCheck: false,//新增自定义范围
      customRangeType: "category",
      isAuth: "pinyin",
      isVisiableCustomRange: false,
      checkList: [],
      checkLists: [],
      advancedQuery: [
        {
          type: "and",
          textType: "1",
          keyword: "",
        },
        {
          type: "and",
          textType: "1",
          keyword: "",
        },
      ],
      neardQuery: [
        {
          spacing: 5,
          keyword: "",
        },
        {
          spacing: 5,
          type: "and",
          keyword: "",
        },
      ],
      selectTreeIndex: 0,
      treeList: {
        category: [], // 类目
        pinyin: [], // 拼音
        dynasty: [], // 朝代
      },

      searchTreeProps: {
        key: "id",
        children: "children",
        label: (item, data) => {
          return item.name + "（" + item.num + "）"
        },
        disabled: (item, data) => {
          if (item.isPermit == 1) {
            return false
          } else {
            return true
          }

        },
      },
      defaultProps: {
        children: "children",
        label: "name",
      },
      defaultTreeProps: {
        children: "children",
        label: "name",
        disabled: (item, data) => {
          if (item.isPermit == 1) {
            return false
          } else {
            return true
          }

        },
      },
      activeName: "",
      activeListName: {},
      uuid: "",
      sortOption: [
        {
          key: "0",
          name: "正序",
        },
        {
          key: "1",
          name: "倒序",
        },
      ],
      searchFilter: {
        writerIds: [],
        dynastyIds: [],
      },
      isSimple: true,
      searchParamsList: {
        category: {},
        pinyin: {},
        dynasty: {},
      },
      sort: "0", //排序 0 正序 1倒序
      sortTypeList: [
        { key: 0, name: "默認" },
        { key: 1, name: "朝代" },
        { key: 2, name: "數量" },
      ],
      searchTree: {
        tree: 1,
        writer: 1,
        dynasty: 1,
      },
      isSearchFilter: false,
      openSearchStatus: {},
      openJuanStatus: {},
      rightOpera: {},
      isCategorySearch: false,
      isDynastySearch: false,
      isPinyinSearch: false,
      isSearching: false,
      loading: false,
      // saerchInfo: {
      //   total: 0,
      //   pageSize: 10,
      //   pageNum: 1
      // },
      empsearch: {
        //搜索空置的情况下分页
        total: 0,
        pageSize: 10,
        pageNum: 1,
        ids: "",
      },
      downLoading: false,
      newloading: false, //滚动加载
      searchAccuracyType: true,//精确or模糊搜索 0 精确 1模糊
      newParam: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        keyword: "",
        type: 0,
        searchType: "0",
        sort: "0", //排序 0 正序 1倒序
        sortType: 0, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
        categoryIds: "",
        writerIds: "",
        dynastyIds: "",
        writerInitials: "",
        bookIds: "",
        advaList: [],
        hitCountType: 0,
        isInnerSearch: 0,//0 全局 1书内检索
        searchAccuracyType: 1,
        isOnlyPermit: 1,//是否全库 0 全局 1仅授权
        textType: "1"
      },
      keywordStr: "", //云~$花蕋~!书   ~代表关键字的分隔符，$意思是条件or， !意思是条件not, 关键字前面没有 $和!代表 and
      xdwenxian: "",//选定文献

    }
  },
  watch: {
    // searchType: d => {
    //   console.log(d);
    // }
    isShow: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          if (this.newParam.searchType == 0) {
            this.leftHeight = 75
            this.contHeight = 63
          } else {
            this.leftHeight = 59
            this.contHeight = 48
          }
        } else {
          this.leftHeight = 87
          this.contHeight = 76
        }
      }
    },
    'newParam.searchType' (newVal) {
      if (this.isShow) {
        if (newVal == 0) {
          this.leftHeight = 75
          this.contHeight = 63
        } else {
          this.leftHeight = 58
          this.contHeight = 48
        }
      } else {
        this.leftHeight = 86
        this.contHeight = 76
      }

    }

  },
  created () {
    this.getTreeData()
  },
  computed: {
    noMore () {
      if (this.isSearching) {
        return this.newParam.total < this.newParam.pageSize

      } else {
        // return this.empsearch.total <= this.empsearch.pageSize * this.empsearch.pageNum
        return this.empsearch.pageNum >= Math.ceil(this.empsearch.total / this.empsearch.pageSize)
        // return false;
      }
    },
    newdisabled () {
      return this.newloading || this.noMore
    },
  },
  mounted () {

    this.mountedmove()
    this.$bus.$on('changeShow', this.changeShow)

    this.$bus.$on('reloadSearch', () => {
      this.mountedmove()
    })
    // getCategoryNode().then(data => {
    //   this.searchResult.tree = data.data;
    //   this.$forceUpdate();
    // });

    // window.addEventListener("mousemove",this.getgetPosY);
    //  window.addEventListener('mousewheel', this.handleScroll, true)||window.addEventListener("DOMMouseScroll",this.handleScroll,false)
    //历史记录

    // console.log(this.$route.path, 'route.path')

  },
  methods: {
    mountedmove () {
      //判断是否游客 是否有权限
      // this.isHaveLimits()
      const { params, query } = this.$route
      //操作列表跳转参数
      if (query.operStr) {
        let operStr = JSON.parse(query.operStr)
        const { searchType, advancedQuery, nearQuery, sortType, sort } = operStr
        if (searchType) {
          this.newParam.searchType = searchType
        }
        if (advancedQuery) {
          this.advancedQuery = advancedQuery
        }
        if (nearQuery) {
          this.nearQuery = nearQuery
        }
        this.newParam.sortType = sortType
        this.newParam.sort = sort
        // this.newParam = operStr
      }

      //操作列表

      getInfo({ 'noopenlogin': true }).then(d => {
        if (d.code == 200) {
          this.isShowQuanKu = true
          let user = d.user
          if (user.isVip == 0 && user.haveAuth == 0) {
            this.newParam.isOnlyPermit = 0
            this.isSimple = false
          } else {
            // console.log('else', this.isSimple)
            this.newParam.isOnlyPermit = 1
            this.isSimple = true
          }
        } else {
          this.isShowQuanKu = false
          this.newParam.isOnlyPermit = 0
          this.isSimple = false
        }
        if (params.keyword || query.keyword || this.newParam.keyword) {
          // this.search = { keyword: query.keyword, advaList: [] };
          this.newParam.keyword = params.keyword || query.keyword || this.newParam.keyword
          this.clickSearch(true)
        } else {
          this.getCategoryNodeData()
        }
      })

      if (JSON.parse(localStorage.getItem("historyList"))) {
        this.historyList = JSON.parse(localStorage.getItem("historyList"))
      }
    },
    // reloadSearch (btn, left) {
    //   this.searchResult.bookList = []
    //   this.newParam.pageNum = 1
    //   this.newParam.total = 0
    //   this.postSearch(btn, left)
    // },
    //判断是否游客 是否有权限
    // isHaveLimits () {
    //   getInfo({ 'noopenlogin': true }).then(d => {
    //     if (d.code == 200) {
    //       let user = d.user
    //       if (user.isVip == 0 && user.haveAuth == 0) {
    //         this.newParam.isOnlyPermit = 0
    //         this.isSimple = false
    //       } else {
    //         // console.log('else', this.isSimple)
    //         this.newParam.isOnlyPermit = 1
    //         this.isSimple = true
    //       }
    //     } else {
    //       this.newParam.isOnlyPermit = 0
    //       this.isSimple = false
    //     }
    //   })

    // },
    rendercontent (h, { node, data, store }) {
      if (!this.isSimple && data.isPermit == 0) {
        return (<span class="el-tree-node__label" style="color:#bbb">{node.label}</span>)
      }
      else {
        return (<span class="el-tree-node__label">{node.label}</span>)
      }
    },
    //修改是否全库
    changePermit () {
      // this.newParam.isOnlyPermit = 0
      // this.getCategoryNodeData()
      this.isSimple = !this.isSimple
      this.$refs.defaultSearchTree &&
        this.$refs.defaultSearchTree.filter(this.isSimple)
    },
    changePermitTwo (isSimple, isOnlyPermit) {
      this.searchResult.tree = []
      this.isSimple = isSimple
      //this.newParam.hitCountType = 0 // 0 获取所有（左侧加右侧） 1只获取右侧  2获取初始树 数量
      this.newParam.isOnlyPermit = parseInt(isOnlyPermit)
      // this.getSearchContent(false)
      this.searchResult.bookList = []
      this.newParam.pageNum = 1
      this.newParam.total = 0
      this.postSearch(true, false)

    },
    getStorages (queryString, cb, key) {
      // console.log(queryString, key, 'key')
      // console.log(this.historyList[key], this.historyList[key])
      if ((!this.historyList[key]) || (this.historyList[key].length == 0)) {
        cb([])
        return
      }
      let results = this.historyList[key]
      let res = []
      results.forEach((item) => {
        res.push({ value: item })
      })
      cb(res)
    },
    storageHistory (key, val) {
      //console.log(this.historyList[key], val, 'kyv')
      //没有搜索记录，把搜索值push进数组首位，存入本地
      if (!this.historyList[key]) {
        this.$set(this.historyList, key, [])
        this.historyList[key].unshift(val)
      }
      else if (!this.historyList[key].includes(val)) {
        this.historyList[key].unshift(val)
      } else {
        //有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
        let i = this.historyList[key].indexOf(val)
        if (i != 0) {
          this.historyList[key].splice(i, 1)
          this.historyList[key].unshift(val)
        }
      }
      if (this.historyList[key] && this.historyList[key].length > 5) {
        //console.log(this.historyList[key].length, 'length')
        this.historyList[key].splice(5)
      }
      localStorage.setItem("historyList", JSON.stringify(this.historyList))
    },
    linkdialog (writerList, copierList, activewriter, bookName) {
      // if (type == 1) {
      //   this.writerIds = item.writerId
      //   this.copierIds = ''
      //   this.activewriter = item.writerName
      // } else {
      //   this.writerIds = ''
      //   this.copierIds = item.copierId
      //   this.activewriter = item.copierName
      // }
      this.writerIds = []
      this.copierIds = []
      writerList && writerList.forEach(ele => {
        this.writerIds.push({ writerId: ele.writerId, name: ele.writerName })
      })
      copierList && copierList.forEach(ele => {
        this.copierIds.push({ copierId: ele.copierId, name: ele.copierName })
      })
      this.activewriter = activewriter
      this.activeBookName = bookName
      this.linkVisible = true
      // this.$bus.$emit("linkdialog", { type, item })

    },
    handleClose (done) {
      if (this.newIsCheck && !this.xdwenxian) {
        this.newIsCheck = false
        done()
      }

    },
    getDetail (isLeaf, data) {
      if (isLeaf) {
        this.$router.push({
          name: 'pageViewer',
          query: {
            bookId: data.realId,
            bookName: data.name,
          },
        })
      }

    },
    changeTreeIndexSearch () {
      this.searchTree.tree = this.searchTree.tree === 1 ? 0 : 1
      // this.$refs.leftCatalogList.default-expand-all = this.selectTreeIndex;
      // 折叠所有节点

      if (this.searchTree.tree == 0) {

        for (var i = 0; i < this.$refs.defaultSearchTree.store._getAllNodes().length; i++) {
          this.$refs.defaultSearchTree.store._getAllNodes()[i].expanded = false
        }
      }
      // 展开所有节点
      if (this.searchTree.tree == 1) {
        for (var i = 0; i < this.$refs.defaultSearchTree.store._getAllNodes().length; i++) {
          this.$refs.defaultSearchTree.store._getAllNodes()[i].expanded = true
        }
      }
    },

    changeShow () {
      this.isShow = !this.isShow
    },

    clearsearch () {

      // this.description = "請在上方輸入關鍵詞檢索，或者在左側選擇文獻閲讀";
      // this.isSearching = false;
      // this.searchResult = {};
      // this.newParam = {
      //   pageSize: 10,
      //   pageNum: 1,
      //   total: 0,
      //   keyword: "",
      //   type: 0,
      //   searchType: "0",
      //   sort: "0", //排序 0 正序 1倒序
      //   sortType: 0, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
      //   categoryIds: "",
      //   writerIds: "",
      //   dynastyIds: "",
      //   writerInitials: "",
      //   bookIds: "",
      //   advaList: [],
      //   hitCountType: 0,
      // };
      this.newParam.keyword = ''
      this.advancedQuery = [
        {
          type: "and",
          keyword: "",
        },
        {
          type: "and",
          keyword: "",
        },
      ]
      this.neardQuery = [
        {
          spacing: 5,
          keyword: "",
        },
        {
          spacing: 5,
          type: "and",
          keyword: "",
        },
      ]
      // }
      // this.getCategoryNodeData();
    },
    getBookListOpenStatus (a, b, c, d) {
      if (this.activeName === a) {
        this.activeName = ""
      } else if (Array.isArray(this.activeName)) {
      }
    },
    closeAllList (item) {
      // console.log('9988')
      this.openSearchStatus[item.bookName] =
        !this.openSearchStatus[item.bookName]
      item.bookJuanList.map((v) => {
        this.openJuanStatus[v.juanName] = this.openSearchStatus[item.bookName]
      })

      this.$forceUpdate()
    },
    downSearch () {
      this.downLoading = true
      exportSearchResult({
        ...this.newParam,
        pageNum: 1,
        pageSize: 1000
      }).then(
        (d) => {
          // console.log(d, 'dd')
          let date = new Date().toLocaleDateString()
          let time = new Date().toLocaleTimeString()
          let ret = this.downBlobFile(
            d,
            "“" + this.newParam.keyword + "”" + "（已授權）的搜索結果——" + date + " " + time
          )
          this.downLoading = false
          // if (ret) {
          //   this.$message('系統暫時只提供1000條的檢索結果')
          // }
        },
        () => (this.downLoading = false)
      )
    },
    // 搜索空置情况下
    getTreeDefaultSearch (data, b, c) {
      // console.log(1)
      // this.$refs.defaultSearchTree.setCheckedKeys([data.key]);
      // getBookList({
      //   id: data.key,
      //   nodeType: data.nodeType,
      //   sort: this.sort
      // }).then(data => {
      //   // console.log(data);
      //   this.searchResult.bookList = data.data.bookList;

      //   this.openAllBook(true);
      //   this.$forceUpdate();
      // });

      let idsarr = this.$refs.defaultSearchTree.getCheckedKeys(true)
      // let ids = b.checkedKeys.join(",");
      this.empsearch.ids = idsarr.join(",")
      this.empsearch.pageNum = 1
      this.searchResult.bookList = []
      this.getlistByIds()
    },
    isornotpermit (data, b, c) {
      // console.log(2)
      if (data.isPermit == 0) { //0未授权
        // this.$router.push({ path: "/products" })
        this.clickChangeBuy(true)

      }

    },

    clickChangeBuy (isShow) {
      getInfo().then(d => {
        if (d.code == 200) {
          eventBus.$emit("changeBuy", isShow)

        }
      })
    },
    getlistByIds () {
      getlistByIdsApi({
        pageSize: this.empsearch.pageSize,
        pageNum: this.empsearch.pageNum,
        ids: this.empsearch.ids,
        // sortType: this.newParam.sortType,
        sortType: 3,
        sort: this.sort,
      }).then((data) => {
        let temprows = data.rows
        temprows.forEach((item) => {
          item.writerarr = item.writerList.reduce(function (r, a) {
            r[a.writerRole] = r[a.writerRole] || []
            r[a.writerRole].push(a)
            return r
          }, Object.create(null))
          // 日期
          // item.publishTime = (item.publishTime && item.publishTime != 'null') ? `${new Date(item.publishTime).getFullYear()}年${new Date(item.publishTime).getMonth() + 1}月` : ''
          item.publishTime = item.publishTime ? item.publishTime.substring(0, 7) : ''
        })
        this.searchResult.bookList = [...this.searchResult.bookList, ...temprows]
        this.empsearch.total = data.total
        // this.isShow = false
        // this.openAllBook(true);
        this.$forceUpdate()
        this.newloading = false
      })
      // window.scrollTo(0, 0);
    },

    // 空置分页
    empSearchChange () {
      this.empsearch.pageNum += 1
      this.getlistByIds()
    },

    getTreeData () {
      this.getCategory()
      this.getPinyin()
      this.getDynasty()
    },
    clearSearchTree () {
      this.search.category = ""
      this.search.pinyin = ""
      this.search.dynasty = ""
      // this.$refs.scopeTreeCat.setCheckedKeys([]);
      // this.$refs.scopeTreeWriterDynasty.setCheckedKeys([]);
      // this.$refs.scopeTreeWriter.setCheckedKeys([]);

      // let tem1 = this.$refs.scopeTreeWriterDynasty;
      // let tem2 =  this.$refs.scopeTreeWriter.getCheckedKeys(true);
      this.getTreeData()
    },
    gotoBookDetail (item) {
      const url = this.$router.resolve("/bookDetail?id=" + item.id)
      window.open(url.href)
    },
    viewAllMoreList () {
      this.openSearchStatus = {}
      this.openJuanStatus = {}

      if (this.changestate == "全部展開") {
        this.searchResult.bookList.forEach((item) => {
          this.openSearchStatus[item.id] = true
          item.bookJuanList.map((v) => {
            this.openJuanStatus[v.juanName] = false
          })
        })

        this.changestate = "全部收起"

        this.$forceUpdate()
      } else {
        //  for(let key in this.openSearchStatus){
        //   delete this.openSearchStatus[key];
        //  }
        //  for(let key in this.openJuanStatus){
        //   delete this.openJuanStatus[key];
        //  }

        this.changestate = "全部展開"

        this.$forceUpdate()
      }
    },
    viewMoreList (item) {
      this.openSearchStatus[item.id] = true

      //  this.openSearchStatus[item.bookName] =
      //   !this.openSearchStatus[item.bookName];
      item.bookJuanList.map((v) => {
        this.openJuanStatus[v.juanName] = false
      })
      this.$forceUpdate()
    },
    openBook (item) {
      if (Array.isArray(this.activeName)) {
        const idx = this.activeName.findIndex((v) => v == item.bookName)
        if (idx > -1) {
          this.activeName.splice(idx, 1)
        } else {
          this.activeName.push(item.bookName)
        }
      } else {
        this.activeName = [item.bookName]
      }
    },
    openAllBook (isAll) {
      if (Array.isArray(this.activeName) && !isAll) {
        return (this.activeName = "")
      }
      this.activeName = this.searchResult.bookList.map((item) => item.bookName)
    },
    getFilter (isSimple, item) {
      // if (!isSimple) return true
      if (isSimple) {

        if (item.totalNum * 1 && item.isPermit == 1) {
          return true
        } else {
          return false

        }

      }
      return true
    },
    getDefaltFilter (isSimple, item) {
      if (isSimple) {
        if (item.bookTotal != "0" && item.isPermit == 1) {
          return true
        }
        return false
      }
      return true
    },
    // if (item.isPermit == 1) {
    //       return true
    //     } else {
    //       return false
    //     }
    viewDetail (item, bookId, pageId, bookName) {
      // 搜索条件结束
      const query = {
        bookId,
        bookName,
        pageId,
        juanNum: item.juanNum
      }

      // 搜索条件开始
      // const firstKeyword = this.search.keyword;
      // const type = this.newParam.searchType;
      // let tempqu = [];
      //   if (type == 2) {
      //     tempqu = this.advancedQuery;
      //     tempqu.unshift({ keyword: firstKeyword });
      //     let temptempqu = JSON.stringify(tempqu);
      //     query.advaList = temptempqu;
      //   }
      //   if (type == 3) {
      //     tempqu = this.neardQuery;
      //     tempqu.unshift({ keyword: firstKeyword });
      //     let temptempqu = JSON.stringify(tempqu);
      //     query.advaList = temptempqu;
      //   }

      let routeData = this.$router.resolve({
        //name:"viewer",
        path: "/pageViewer",
        query,
      })

      window.open(routeData.href, "_blank")
    },
    getSearchTreeChecked (item, type, keys) {
      const key = item.key
      let searchParams
      let paramKey
      if (keys) {
        searchParams = this[keys]
      } else {
        if (this.customRangeType == "category") {
          paramKey = this.customRangeType
        } else {
          paramKey = this.isAuth
        }
        searchParams = this.searchParamsList[paramKey]
      }

      if (item.nodeType === "book") {
        searchParams.bookIds = searchParams.bookIds || []
        let findIndex = searchParams.bookIds.findIndex((v) => v == key)
        if (findIndex > -1) {
          searchParams.bookIds.splice(findIndex, 1)
        } else {
          searchParams.bookIds.push(key)
        }
      }
      if (item.nodeType === "writer") {
        searchParams.writerIds = searchParams.writerIds || []
        let findIndex = searchParams.writerIds.findIndex((v) => v == key)
        if (findIndex > -1) {
          searchParams.writerIds.splice(findIndex, 1)
        } else {
          searchParams.writerIds.push(key)
        }
      }
      if (item.nodeType === "category") {
        searchParams.categoryIds = searchParams.categoryIds || []
        let findIndex = searchParams.categoryIds.findIndex((v) => v == key)
        if (findIndex > -1) {
          searchParams.categoryIds.splice(findIndex, 1)
        } else {
          searchParams.categoryIds.push(key)
        }
      }
      if (item.nodeType === "dynasty") {
        searchParams.dynastyIds = searchParams.dynastyIds || []
        let findIndex = searchParams.dynastyIds.findIndex((v) => v == key)
        if (findIndex > -1) {
          searchParams.dynastyIds.splice(findIndex, 1)
        } else {
          searchParams.dynastyIds.push(key)
        }
      }
      if (item.nodeType === "letter") {
        searchParams.writerInitials = searchParams.writerInitials || []
        let findIndex = searchParams.writerInitials.findIndex((v) => v == key)
        if (findIndex > -1) {
          searchParams.writerInitials.splice(findIndex, 1)
        } else {
          searchParams.writerInitials.push(key)
        }
      }
      if (!keys) {
        this.searchParamsList[paramKey] = searchParams
      }
    },
    getCategory () {
      booksTree({
        parentId: "0",
        nodeType: "category",
        keyword: this.search.category,
      }).then((d) => {
        this.treeList.category = d.data
        this.isCategorySearch = !!this.search.category
      })
    },

    getPinyin () {
      booksTree({
        parentId: "0",
        nodeType: "letter",
        keyword: this.search.pinyin,
      }).then((d) => {
        this.treeList.pinyin = d.data
        this.isPinyinSearch = !!this.search.pinyin
      })
    },
    getDynasty () {
      booksTree({
        parentId: "0",
        nodeType: "dynasty",
        keyword: this.search.dynasty,
      }).then((d) => {
        this.treeList.dynasty = d.data
        this.isDynastySearch = !!this.search.dynasty
      })
    },
    newload () {
      this.newloading = true
      setTimeout(() => {
        if (this.isSearching) {
          this.newParam.pageNum += 1
          this.postSearch()

        } else {
          this.empSearchChange()

        }
      }, 2000)
    },
    // 按钮查询
    clickSearch (isBtnSearch = false, isLeftTree = false) {

      // $event.stopPropagation();//阻止冒泡
      // 头部按钮搜索 更新左侧右侧
      if (isBtnSearch) {
        //参数恢复初始值
        let tempParam = {
          pageSize: 10,
          pageNum: 1,
          total: 0,
          // keyword:'',
          type: 0,
          // searchType: "0",
          sort: "0", //排序 0 正序 1倒序
          sortType: 0, //排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
          categoryIds: "",
          writerIds: "",
          dynastyIds: "",
          writerInitials: "",
          bookIds: "",
          advaList: [],
          hitCountType: 0,
        }
        this.searchFilter = {
          writerIds: [],
          dynastyIds: [],
        }
        this.newParam = { ...this.newParam, ...tempParam }
        if (this.newParam.searchType == 1) {
          this.newParam.advaList = this.advancedQuery.filter((item) => {
            return item.keyword !== ""
          })
        }
        if (this.newParam.searchType == 2) {
          this.newParam.advaList = this.neardQuery.filter((item) => {
            return item.keyword !== ""
          })
        }

        //搜索范围
        // if (this.rangeType == 2) {
        if (this.newIsCheck) {
          let checkedKeys = []
          if (this.customRangeType == "category") {
            checkedKeys = this.$refs.scopeTreeCat && this.$refs.scopeTreeCat.getCheckedKeys(true)
            this.storageHistory(`category`, this.search.category)//输入框历史记录

          } else {
            checkedKeys =
              this.isAuth === "dynasty"
                ? this.$refs.scopeTreeWriterDynasty && this.$refs.scopeTreeWriterDynasty.getCheckedKeys(true)
                : this.$refs.scopeTreeWriter && this.$refs.scopeTreeWriter.getCheckedKeys(true)

            //输入框历史记录
            this.isAuth === "dynasty"
              ? this.storageHistory(`dynasty`, this.search.dynasty) : this.storageHistory(`pinyin`, this.search.pinyin)
          }
          if (checkedKeys) this.newParam.bookIds = checkedKeys.join(",")

        }
        // this.clearSearchTree()
        // }
        // if (this.rangeType == "1") {
        //   this.newParam.bookIds = ""
        // }
        //模糊查询精确查询
        this.newParam.searchAccuracyType = this.searchAccuracyType ? 1 : 0
      }
      //左侧树选择 更新右侧数据和列表
      let handleFields = [
        "categoryIds",
        "writerIds",
        "dynastyIds",
        "writerInitials",
        "bookIds",
      ]
      if (isLeftTree) {
        this.isSearchFilter = false
        this.searchFilter.bookIds = this.$refs.treeList.getCheckedKeys(true)
        let tempSearchFilter = JSON.parse(JSON.stringify(this.searchFilter))
        handleFields.map((fields) => {
          if (tempSearchFilter[fields]) {
            tempSearchFilter[fields] = tempSearchFilter[fields].join()
          }
        })
        this.newParam = { ...this.newParam, ...tempSearchFilter }
      }

      //搜索框历史搜索
      if (this.newParam.advaList) {
        let keystr = ''
        if (this.newParam.searchType == 1) {
          keystr = 'advanced'
        } else if (this.newParam.searchType == 2) {
          keystr = 'neard'
        }
        this.newParam.advaList.forEach((item, index) => {
          this.storageHistory(`${keystr}${index}`, item.keyword)
        })
      }
      if (this.newParam.keyword) {
        this.storageHistory('keyword', this.newParam.keyword)
      }

      this.searchResult.bookList = []
      this.newParam.pageNum = 1
      this.newParam.total = 0

      this.postSearch(isBtnSearch, isLeftTree)


    },
    // 最近操作
    addLatest (type) {
      const { keyword, advaList, searchType, sortType, sort, isInnerSearch, searchAccuracyType } = this.newParam
      let tempoper = {
        keyword, advaList, searchType, sortType, sort, isInnerSearch, searchAccuracyType
      }
      if (this.newParam.searchType == 1) {
        tempoper.advancedQuery = this.advancedQuery
      }
      if (this.newParam.searchType == 2) {
        tempoper.nearQuery = this.nearQuery
      }

      let param = {
        guestId: this.$getUUID(),
        operType: "search",
        operStr: JSON.stringify(tempoper)
      }
      // console.log(param, 'param')
      addLatest(
        param
      ).then((e) => {
        console.log(e)
      })
    },
    // 查询
    postSearch (isBtnSearch = false, isLeftTree = false) {
      // this.isFanwei = false;
      // this.newloading = true
      this.description = "正在查詢 請等候"

      this.changestate = "全部展開"
      if (!this.newParam.keyword) {
        return this.$message.warning("請輸入或選擇書名")
      }
      this.loading = true
      this.isSearching = true
      // console.log(this.newParam, 'this.newParam')
      // this.isHaveLimits()
      // if (this.newParam.searchType != 2) { //near查詢左侧树在列表查詢后
      //   if (isBtnSearch) {
      //     this.searchResult.tree = []
      //     this.newParam.hitCountType = 0
      //     this.getSearchContent()
      //     this.searchFilter.type = "0"
      //   }
      //   if (isLeftTree) {
      //     this.newParam.hitCountType = 1 // 0 获取所有（左侧加右侧） 1只获取右侧  2获取初始树 数量
      //     this.getSearchContent()
      //     this.searchFilter.type = "0"
      //   }
      // }
      essearch(this.newParam).then(
        (data) => {
          // console.log(data, 'dsfdata')
          this.catalogIdList = data.data.catalogIdList
          this.newParam.numResultList = data.data.numResultList  //numResultList搜索返回，作为获取数量参数
          this.keywordStr = data.data.keywordStr
          let tempBookList = data.data.bookList

          if (data.data.bookList.length == 0 && this.searchResult.numArr[0].value != 0) { this.description = "符合條件的結果數據量過於龐大，不再展示,敬請諒解。" } else if (data.data.bookList.length == 0) { this.description = "没有符合條件的結果" }

          this.newParam.total = data.data.bookList.length

          this.loading = false
          // this.newloading = false;
          this.isVisiableCustomRange = false
          // if (this.newParam.searchType == 2) { //near查詢左侧树在列表查詢后
          if (isBtnSearch) {
            this.searchResult.tree = []
            this.newParam.hitCountType = 0
            this.getSearchContent()
            this.searchFilter.type = "0"
          }
          if (isLeftTree) {
            this.newParam.hitCountType = 1 // 0 获取所有（左侧加右侧） 1只获取右侧  2获取初始树 数量
            this.getSearchContent()
            this.searchFilter.type = "0"
          }
          // }

          //新增4/6拼接作者等
          tempBookList.forEach((item) => {
            item.writerarr = item.writerList.reduce(function (r, a) {
              r[a.writerRole] = r[a.writerRole] || []
              r[a.writerRole].push(a)
              return r
            }, Object.create(null))
          })


          this.searchResult.bookList = [
            ...this.searchResult.bookList,
            ...tempBookList,
          ]
          // this.searchResult.bookList = tempBookList;
          this.activeName =
            this.searchFilter.type == 3
              ? ""
              : this.searchResult.bookList.map((item) => {
                this.activeListName[item.id] =
                  item.bookJuanList[0] && item.bookJuanList[0].juanName
                return item.bookName
              })

          if (localStorage.token && this.newParam.pageNum == 1) this.addLatest(2)
          this.$forceUpdate()

          // this.hightLighyt();
          this.newloading = false
        },
        () => (this.loading = false)
      )
      // setTimeout(() => {
      //   this.isShow = false
      //   this.chaoShow = false
      // }, 1000)
      window.scrollTo(0, 0)
    },

    getCategoryNodeData () {
      // booksTree({
      //   parentId: "0",
      //   nodeType: "category",
      // }).then((data) => {
      // let isOnlyPermit = this.newParam.isOnlyPermit
      this.emptyText = "查詢中..."
      getHitCount({
        hitCountType: 2,
        // isOnlyPermit
      }).then((data) => {
        // console.log(data, 'data')
        this.searchResult.tree = data.data.tree

        this.$forceUpdate()
        if (this.isSearching) {
          this.emptyText = "暫無數據"
          this.$nextTick(
            () =>

              this.$refs.treeList && this.$refs.treeList.filter(this.isSimple)
          )
        } else {
          this.emptyText = "暫無授權文獻"
          this.$nextTick(
            () =>
              this.$refs.defaultSearchTree &&
              this.$refs.defaultSearchTree.filter(this.isSimple)
          )
        }

      })
    },

    getSearchContent (isRight = true) {
      this.emptyText = "查詢中..."
      getHitCount(this.newParam).then((data) => {
        if (this.newParam.hitCountType == 0) {
          this.searchResult.dynastyList = data.data.dynastyList
          this.searchResult.writerList = data.data.writerList
          this.searchResult.tree = data.data.tree

          // this.bookNum = data.data.bookNum
          // this.totalNum = data.data.totalNum
        }
        this.emptyText = "没有符合條件的結果"
        this.$forceUpdate()
        this.$nextTick(() => {
          this.$refs.treeList && this.$refs.treeList.filter(this.isSimple)
        })
        // if (isRight) {
        this.searchResult.numArr = [
          {
            name: "全部",
            value: data.data.totalNum,
            type: "0",
          },
          {
            name: "正文",
            value: data.data.mainNum,
            type: "1",
          },
          {
            name: "校記",
            value: data.data.noteNum,
            type: "2",
          },
          {
            name: "專名",
            value: 0,
            type: "10",
          },
          // {
          //   name: "書名",
          //   value: data.data.bookNum,
          //   type: "3",
          // },
        ]
        // }

        // this.searchResult.dynastyList = data.data;
        // this.$forceUpdate();
      })
    },
    setRangeType (idx) {
      if (idx === 11) {
        if (this.newIsCheck) {
          this.isVisiableCustomRange = !this.isVisiableCustomRange
        } else {
          this.xdwenxian = ''
        }
      } else if (idx === 2) {
        // this.isFanwei = true;
        // this.isVisiableCustomRange = true;
        this.isVisiableCustomRange = !this.isVisiableCustomRange
        this.getWxFanWei()
      } else {
        // this.isFanwei = false;
        this.isVisiableCustomRange = false
        this.clearSearchTree()
      }
      // this.rangeType = this.rangeType === idx ? "" : idx;
      this.rangeType = idx
    },
    getWxFanWei () {
      let arra = []
      let a = this.$refs.scopeTreeCat.getCheckedNodes(true)
      let b = this.$refs.scopeTreeWriterDynasty.getCheckedNodes(true)
      let c = this.$refs.scopeTreeWriter.getCheckedNodes(true)

      arra = [...a, ...b, ...c]

      let xdwenxianarr = arra.map((item) => {
        return item.name
      })

      this.xdwenxian = xdwenxianarr.join('，')
    },
    setSearchFilter () {
      // const { dynastyIds, writerIds } = this.searchFilter
      // this.isSearchFilter =
      //   (dynastyIds && dynastyIds.length) ||
      //   (writerIds && writerIds.length) ||
      let ids = this.$refs.treeList.getCheckedKeys(true).length
      console.log(ids, 'ids')
      this.$forceUpdate()
    },
    typeSearch (type) {
      //  this.searchFilter['type'] = type;

      this.newParam.type = type == "3" ? 0 : type
      // this.newParam.type = type;
      this.searchFilter.type = type
      this.$forceUpdate()
      if (type != 3) this.clickSearch(false, false)
    },
    getClientInfo (e, ele) {
      this.dragEle = ele
      this.rightOpera = {
        width: this.$refs[ele].$el
          ? this.$refs[ele].$el.clientWidth
          : this.$refs[ele].clientWidth,
        startX: e.clientX,
        isMouseDown: true,
      }
    },
    moveClient (e, ele) {
      if (!this.rightOpera.isMouseDown) {
        return
      }
      e.stopPropagation()
      e.preventDefault()
      const { startX } = this.rightOpera
      let offsetWidth = e.clientX - startX
      if (this.dragEle === "leftDragCate") {
        offsetWidth = startX - e.clientX
      }

      let el = this.$refs[this.dragEle].$el || this.$refs[this.dragEle]
      el.style.width = this.rightOpera.width - offsetWidth + "px"
      this.$forceUpdate()
    },
    mouseUp () {
      this.rightOpera = {
        isMouseDown: false,
      }
    },
  },
  beforeDestroy () {
    this.$bus.$off("changeShow")

    this.$bus.$off('reloadSearch')
  }
};
</script>

<style lang="less" scoped>
@primary-color: #f4f0e8;
@first-color: #2c7e8d;
@secont-color: #666666;
@three-color: #999999;
@four-color: #333333;
@PingFang-SC-Medium: PingFang-SC-Medium;
@PingFangSC-Regular: PingFangSC-Regular;
@PingFang-SC-Bold: PingFang-SC-Bold;
@PingFang-SC-ExtraLight: PingFang-SC-ExtraLight;
.mengban {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
}
@import url(../assets/iconfont.css);
/deep/.el-input-number.is-controls-right .el-input__inner {
  padding-left: 10px;
}
/deep/.el-autocomplete {
  width: 100%;
}
.checkboxstyle {
  margin-left: 20px;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #3366cc;
}
.xinghao {
  // color: #3366cc;
  color: #e60012;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #3366cc;
  border-color: #3366cc;
}
/deep/ .el-dialog {
  width: 80%;
}
/deep/.el-dialog__body {
  padding: 0 20px 30px;
}

.heitani {
  transition: height 0.3s linear;
  will-change: height;
}
.margin-ri {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 1.15rem;
  margin-top: 0.5rem;
}
.topbottom {
  width: 100%;
  height: 1.5rem;
  text-align: center;
  // line-height: 2rem;
  // position:absolute;
  // opacity: 0;
  position: relative;
  img {
    position: absolute;
    cursor: pointer;
    height: 1rem;
    //  animation:mymove 2s infinite;
  }
  .totop {
    animation: mymove 2s infinite;
  }
  .tobottom {
    animation: mymovetwo 2s infinite;
  }
}
@keyframes mymove {
  from {
    bottom: 0px;
    opacity: 100;
  }
  to {
    bottom: 5px;
    opacity: 0;
  }
}
@keyframes mymovetwo {
  from {
    top: 0px;
    opacity: 0;
  }
  to {
    top: 5px;
    opacity: 100;
  }
}

// /deep/ .el-input-group__prepend{
//   padding-left:10px;
//   padding-right: 0px;
// }
// /deep/ .el-input__inner{
//   padding: 0 20px;
// }
// /deep/ .el-input{
//   width: 90%;
// }
// /deep/.icon-menu{
//   // color:#1b1b1b
//   cursor: pointer;
// }

.submit-btn {
  width: 4.6rem;
  height: 100%;
  margin-left: 2rem;
  font-size: 1rem;
  padding: 8px 20px 8px 20px;
  color: #fff;
  background-color: #3366cc;
  border-color: #3366cc;
}
.submit-btn :hover,
.submit-btn :focus {
  background: var(--el-button-hover-color);
  border-color: var(--el-button-hover-color);
  color: var(--el-button-font-color);
}
.searchA {
  background-color: #3366cc;
  border-color: #3366cc;
  font-size: 1rem;
  padding: 8px 16px 6px 16px;
}
.cover {
  display: flex;
  .btn {
    padding: 0.3rem 0.9rem;
    background: #e6e6e6;
    border-radius: 1rem;
    font-size: 0.8421rem;
    text-align: center;
    cursor: pointer;
    color: #1b1b1b;
    margin-right: 1.15rem;

    &:not(disabled=disabled):hover {
      background: #3366cc;
      color: #fff;
    }
    &.active {
      background: #3366cc;
      color: #fff;
    }
    &[disabled="disabled"] {
      cursor: not-allowed;
    }

    img {
      width: 0.94rem;
    }
  }
  .margin {
    margin: 0.65rem 0;
  }
  .marginNew {
    margin: 1.2rem 0 0.65rem;
  }
  .search-box {
    padding: 2rem 0 1rem;
    box-shadow: 0rem 0rem 1rem 0rem rgba(112, 112, 112, 0.2);
    // background: #f0f8ff;
    > .content {
      width: 86rem;
      margin: 0 auto;
      min-width: 1000px;
      max-width: 100%;
    }
    .left-input-box {
      width: 38rem;
      /deep/ .el-input-group__prepend {
        width: 8rem;
      }
      /deep/ .input-select {
        // display: block;
        margin-bottom: 1rem;
        // > .el-input__inner {
        //   width: 27rem;
        // }
        // &:first-child .el-input__inner{
        //   width: 31.2rem;
        // }

        // &.input-select-label {
        //   .el-input__inner {
        //     // width: 23.5rem;
        //     text-align: center;
        //   }
        // }
      }

      .after {
        width: 1.15rem;
        height: 1.15rem;
        cursor: pointer;
      }
    }

    .search-range {
      width: 36rem;
      // height: 7.74rem;
      height: 1.04rem;
      margin-top: 8px;
      // background: #ffffff;
      // border: 0.1rem solid #c9c9c9;
      // border-radius: 0.4rem;
      // padding: 0.52rem 0.78rem;
      color: #3366cc;
      font-size: 16px;
      cursor: pointer;
      /deep/ .el-tree {
        height: 20rem;
        overflow-y: auto;
      }
      /deep/ .el-dialog {
        width: 680px;
      }
      .zdbox {
        display: flex;
        flex-direction: column;
      }
      .zdxuanze {
        display: flex;
        margin-top: 8px;
        margin-left: 24px;
      }
      .weixuanze {
        font-size: 12px;
        color: #3366cc;
        margin-top: 8px;
        padding-left: 24px;
        i {
          font-style: normal;
          color: #606266;
        }
      }
      .zidingyi {
        display: block;
        width: 150px;
      }
      // .xdwenxianborder {
      //   border: 1px solid #eee;
      //   border-radius: 3px;
      //
      //   margin-top: 0px;
      //   padding: 8px;

      // }
      .kuohao {
        font-size: 30px;
      }
      .xdwenxian {
        display: block;
        width: 30rem;
        margin: 0 5px;
        // height: 2rem;
        // padding: 5px;

        // width: 100%;
        // display: flex;
        font-size: 12px;
        line-height: 16px;

        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .select-range {
        padding: 1.77rem 3.75rem;

        /deep/ .el-checkbox__label {
          color: #3366cc;
        }
        i {
          cursor: pointer;
        }
      }

      /deep/ .el-tree-node {
        font-size: 14px;
      }
      /deep/ .el-tree-node .el-tree-node .el-tree-node {
        white-space: pre-wrap;
      }
      /deep/ .el-tree-node .el-tree-node .el-tree-node .el-tree-node__content {
        // font-size: .8947rem;
        height: auto;
        line-height: 26px;
        span:nth-child(3) {
          display: inline-block;
          box-sizing: border-box;
          padding-right: 42px;
          width: 100%;
          // flex:1
          // line-height: 20px;
        }
      }
    }
  }
  .borderline {
    height: 100%;
    width: 100%;
    // border-bottom: 0.1rem solid #ccc;
    // border-top:0.1rem solid #ccc;
    .borderlinecon {
      width: 80%;
      // height: 10px;
      margin: 0 auto;
      border-top: 1px solid #ccc;
    }
    // .topline{

    // }
    // .bottomline{
    //   border-bottom:1px solid #ccc;
    // }
  }

  .content-box {
    // display: flex;
    display: -webkit-box;
    flex: 1;
    flex-grow: 1;
    overflow: auto;
    // margin-top: 1rem;
    .open-all-btn {
      margin-left: 24px;
      cursor: pointer;
    }
    .tree-list {
      // padding: 24px;
      padding-left: 24px;
      padding-right: 15px;
      width: 350px;
      position: relative;
      padding-bottom: 50px;
      // overflow: auto;
      // overflow-y: scroll;
      overflow: hidden;
      .drag-box {
        left: initial;
        right: 0;
      }
      .simplestyle {
        // width: 290px;
        margin: 10px auto 5px;
      }
      .treescroll {
        height: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        padding-right: 5px;
        padding-bottom: 50px;
        // .simplestyle {
        //   width: 290px;
        //   margin-top: 10px;
        // }
      }
      img {
        width: 1.56rem;
      }
      .tree {
        margin: 0;
        font-size: 18px;
        color: #1b1b1b;
        padding: 12px 0;
        border-bottom: 0.1rem solid #ccc;
        .padding-left {
          padding-left: 1.6rem;
        }
        .left-width {
          width: 290px;
        }
        .titles {
          margin-bottom: 1.5rem;
        }
        .right-icon {
          font-size: 1.2rem;
          color: #9999;
          cursor: pointer;
        }
      }
    }
    .select-content {
      flex: 3;
      // background: #f5f9ff;
      padding: 1.4rem;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 4px;

      .head-condition {
        padding: 0 1.4rem 1rem;
        .label {
          font-size: 1.04rem;
          // font-family: FZShuSong-Z01T;
          // font-weight: bold;
          color: #1b1b1b;
        }
      }

      .head-title {
        // color: #3366cc;
        // font-size: 1.2632rem;
        flex: 1;
        flex-grow: 1;

        font-family: @PingFang-SC-Medium;
        font-size: 16px;
        color: #002f38;
        letter-spacing: 0;
        line-height: 16px;
        font-weight: 500;

        // 原来列表的箭头不能控制传参 使用该icon模拟
        i {
          margin-top: 1rem;
          font-size: 13px;
          margin-right: 8px;
          opacity: 0;
        }
      }
      .book-number {
        color: #3366cc;
        font-size: 1.15rem;

        padding-right: 0.36rem;
      }
      .sm-title {
        // color: #3366cc;
        // font-size: 0.73rem;
        font-family: @PingFang-SC-Medium;
        font-size: 12px;
        color: @first-color;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 500;
      }
      .juan-title {
        font-size: 0.94rem;

        font-weight: bold;
        color: #3366cc;
        font-family: @PingFang-SC-Medium;
        font-size: 12px;
        color: @first-color;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 500;
        // margin-top:.94rem;
        i {
          cursor: pointer;
        }
        .num {
          font-size: 0.73rem;
          padding-left: 0.63rem;
        }
      }

      .search-content-box {
        width: 90%;
        color: #313131;
        font-size: 0.94rem;
        // box-sizing: border-box;
        margin-bottom: 0.8rem;
        line-height: 2;

        > .search-info-box {
          // border-bottom: 0.1rem solid #999;
          // padding-bottom: 0.42rem;
          // margin-bottom: 0.42rem;
        }
        .search-info {
          padding-right: 1.88rem;
          // font-size: 0.83rem;
          font-family: @PingFangSC-Regular;
          font-size: 12px;
          color: @three-color;

          letter-spacing: 0;
          line-height: 3;
          font-weight: 400;

          .icon {
            width: 1.15rem;
            margin-right: 0.3rem;
            // cursor: pointer;
          }
          ul {
            display: flex;
          }
          i {
            font-style: normal;
            opacity: 1;
            margin: 0;
            font-size: 12px;
          }
        }
        .content {
          flex: 1;
          flex-grow: 1;
          // font-size: 0.94rem;

          // color: #313131;
          // line-height: 2.3rem;
          overflow: hidden;
          // white-space: nowrap;
          text-overflow: ellipsis;
          font-family: @PingFang-SC-ExtraLight;
          font-size: 14px;
          color: @four-color;
          letter-spacing: 0;
          // line-height: 18px;
          font-weight: 400;
          margin-top: 10px;

          &.in-title {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .book-icon {
          width: 1.15rem;
          height: 1.15rem;
          margin-left: 1rem;
          cursor: pointer;
        }
        .search-content {
          // margin-top: 0.52rem;
          width: 100%;
          &.list {
            // cursor: pointer;
          }
          .sort {
            font-size: 1.04rem;

            // color: #e60012;
            color: @four-color;
            // padding-right: 1rem;
            margin-top: 10px;
          }
        }
      }
    }
  }

  .search-icon {
    font-size: 18px;
    display: flex;
    height: 100%;
    align-items: center;
    cursor: pointer;
  }
}
.fixed-btn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.span-ellipsis {
  width: 100%;
  font-size: 14px;
  //overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.second-btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  padding: 10px 24px;
  background: #fff;
  // border-top: 0.1rem solid #ccc;
}
/deep/ .el-collapse-item__header {
  height: auto;
  align-items: flex-start;
  position: relative;
  line-height: 2rem;
  border-bottom: none;

  .el-collapse-item__arrow {
    display: none;
    margin-top: 1rem;
    position: absolute;
    right: 0;
    pointer-events: none;
  }
}
/deep/ .el-collapse {
  // border-bottom-color: #ccc;
  border-top: none;
}

/deep/ .el-collapse-item__wrap {
  border-bottom: none;
}
/deep/ .el-collapse-item {
  border-bottom: 1px solid #ccc;
  position: relative;
}
/deep/ .el-collapse-item__content {
  padding-bottom: 5px;
  line-height: 1.8rem;
}
/deep/ .cursorauto {
  cursor: auto;
}
/deep/ .cursorpointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/search3.vue